export default "__VITE_ASSET__5ee58b8c__"